<div class="sp-pt-96 sp-px-64 sp-pb-64">
  <div class="sp-mb-12 fs-30px bold">{{ "manage_reflections_title" | localize }}</div>

  <p *ngIf="team" class="text-color-gray-9">{{ "manage_reflections_description" | localize: { teamName: team.name } }}</p>

  <div ui-row [uiAlign]="'middle'" class="sp-mt-24 fs-16px bold">
    {{ "manage_reflections_enable_team_reflections" | localize }}
    <ui-toggle class="sp-ml-12" [key]="'reflections'" [ngModel]="isTeamReflectionEnabled" (ngModelChange)="onToggleReflection()" [uiType]="'toggle'"></ui-toggle>
  </div>

  <div class="gh-modal-close-button" (click)="close()" role="button">
    <ui-icon [uiClass]="'nc-icon-outline icon ui-1_simple-remove'"></ui-icon>
  </div>

  <div class="sp-mt-48" *ngIf="isTeamReflectionEnabled">
    <ui-tabset>
      <ui-tab uiClosable [uiTitle]="'Questions'">
        <div ui-row>
          <manage-reflection-questions (onQuestionDeleted)="deleteQuestion($event)" (onQuestionUpdated)="updateQuestion($event)" ui-col [uiXs]="24" [questions]="questions" [formGroup]="formGroup">
          </manage-reflection-questions>
        </div>
        <div ui-row [formGroup]="formGroup" class="sp-mt-12">
          <div ui-col [uiXs]="24" *ngIf="showQuestionInput">
            <div ui-row>
              <div ui-col [uiXs]="24">
                <label class="fs-12px fw-400" for="new-question-input">{{ "manage_reflections_new_question" | localize }}</label>
              </div>
              <div ui-col [uiXs]="22">
                <ui-form-item class="sp-mb-4">
                  <ui-form-control>
                    <input ui-input type="text" id="new-question-input" formControlName="newQuestionTitle" placeholder="Write your question" (keyup.enter)="addCustomQuestion()" />
                  </ui-form-control>
                </ui-form-item>
              </div>
              <div ui-col [uiXs]="2">
                <ui-form-control>
                  <ui-form-item class="sp-mb-0 justify-cont-c">
                    <a (click)="toggleCustomQuestion()"><ui-icon uiTheme="outline" uiType="trash-bin" class="fs-16px"></ui-icon></a>
                  </ui-form-item>
                </ui-form-control>
              </div>
            </div>
            <div ui-row>
              <div ui-col [uiXs]="24">
                <div class="fs-10px text-color-gray-9">{{ "manage_reflections_press_enter_to_save" | localize }}</div>
              </div>
            </div>
          </div>
          <div ui-col [uiXs]="24" *ngIf="!showQuestionInput">
            <div class="sp-ml-24 text-color-primary-8 hov-cursor-p" [hidden]="showQuestionInput" (click)="toggleCustomQuestion()">{{ "manage_reflections_create_custom_question" | localize }}</div>
          </div>
        </div>
      </ui-tab>

      <ui-tab uiClosable [uiTitle]="'Schedule'">
        <manage-reflection-schedule></manage-reflection-schedule>
      </ui-tab>
    </ui-tabset>
  </div>
</div>
